<template>
  <div class="vehicle-gallery" @click.self="triggerClose" :class="{ 'vehicle-gallery--visible': visible }">
    <div class="vehicle-gallery__close" @click.self="triggerClose">&#10005;</div>
    <div class="vehicle-gallery__inner">
      <div class="vehicle-gallery__image">
        <img :src="mainImage" alt="Vehicle Image" />
      </div>
      <div class="vehicle-gallery__thumbs">
        <div v-for="(url, index) in thumbs" class="vehicle-gallery__thumb" :class="{'selected': selectedIndex === index}" @click="setSelected(index)">
          <img :src="url" alt="Vehicle Thumbnail" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { EventBus } from '@/event-bus';

export default {
  name: 'VehicleGallery',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    startingIndex: {
      type: Number,
      required: false
    },
    images: {
      type: Array,
      required: true
    },
    thumbs: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedIndex: 0,
    }
  },

  mounted() {
    if (this.startingIndex) {
      this.selectedIndex = this.startingIndex;
    }
  },

  computed: {
    mainImage() {
      return this.images[this.selectedIndex];
    }
  },
  methods: {
    setSelected(index) {
      this.selectedIndex = index;
    },
    triggerClose() {
      EventBus.$emit('vehicle-gallery-close');
    }
  },
  watch: {
    startingIndex: {
      immediate: true,
      handler(value) {
        if (!isNaN(value)) {
          this.selectedIndex = value;
        }
      }
    },
  }
}
</script>
